// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4283":"5760c82d","6211":"2a028ab3"}[chunkId] + ".chunk.css";
};